import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { School } from '../interfaces/School';

export async function getSchools(): Promise<StandardResponse<School[]>> {
    const response: AxiosResponse<StandardResponse<School[]>> = await api.get("/schools");
    return response.data;
}